import UserJobRepository from '../repositories/UserJobRepository';

class UserJobService {
  constructor() {
    this.userRepository = new UserJobRepository();
  }

  async create(data) {
    return this.userRepository.create(data);
  }

  async update(data) {
    return this.userRepository.update(data);
  }

  async delete({ organizationId, userJobId }) {
    return this.userRepository.delete({ organizationId, userJobId });
  }

  async getUserJob({ organizationId, userJobId }) {
    return this.userRepository.getUserJob({ organizationId, userJobId });
  }
}

export default UserJobService;
